<template>
  <div style="position: relative">
    <div :class="[description==null?'page-header':'page-large-header']">
      <h2 class="font-weight-bold">{{ title }}</h2>
      <h4 v-if="description!=null" class="w-40 mt-8">{{description}}</h4>
    </div>
    <div class="page-header-bottom-border">
      <img width="100%"
           height="100%"
           contain
           src="../../assets/images/vBorder.png" alt="border">
    </div>
  </div>
</template>
<script>
export default {
  name: 'TriangleHeader',
  props:{
    title:String,
    description:null,
  }
}
</script>
